<template>
  <div>
    <v-breadcrumbs :items="items">
      <template v-slot:item="props">
        <v-breadcrumbs-item
          :class="props.item.href ? 'enabled' : 'disabled'"
          :disabled="!props.item.href"
          @click="$router.push(props.item.href)"
        >
          {{ props.item.text.toUpperCase() }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
export default {
  name: 'AppBreadcrumbs',

  props: {
    icon: {
      type: String,
      required: false,
      default: 'home',
    },
    items: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },

  beforeUpdate() {
    this.items.sort((item1, item2) => item1.position - item2.position);
  },
};
</script>

<style scoped>
.enabled {
  color: #348eca;
  cursor: pointer;
}

.disabled {
  color: grey;
  pointer-events: none;
}
</style>
